// extracted by mini-css-extract-plugin
module.exports = {"root":"SessionSettingsPage_root__1C_Hk","row":"SessionSettingsPage_row__1pmNv"};